import React, { useState, useEffect } from 'react';
import { Modal, Container, Card, Row } from 'react-bootstrap';
import { useAlert } from 'react-alert';
import './detailNew.css';
import '../../assets/css/Offcanvas.css';
import './popup.css';
import '../../assets/css/productDetail.css';
import './UpdtProPopup.css';
import variables from '../../Variables.json'

function NewPriceOfferPopup({ show, onHide, productData, onYes, onNo, onNewPriceSubmit, closeNotificationAndRefresh }) {
  const alert = useAlert();
  const [showPriceInput, setShowPriceInput] = useState(false);
  const [newPrice, setNewPrice] = useState('');
  const [marginError, setMarginError] = useState(false);
  const [selectedGst, setSelectedGst] = useState(productData?.taxClass);
  const [selectedCombination, setSelectedCombination] = useState(null);
  const [stock, setStock] = useState('');
  const [stockError, setStockError] = useState(false);
  const [stockNotPresent, setStockNotPresent] = useState(false);

  useEffect(() => {
    setSelectedGst(productData?.taxClass);
  }, [productData?.taxClass]);

  // Reset selectedCombination when productData changes (combinations are updated)
  useEffect(() => {
    setSelectedCombination(null);
  }, [productData?.combinations]);


  useEffect(() => {
    // Check if stock is present in productData or selected combination
    let stockAvailable = false;

    if (selectedCombination) {
      stockAvailable = selectedCombination.stock !== undefined && selectedCombination.stock !== null;
    } else if (productData) {
      stockAvailable = productData.stock !== undefined && productData.stock !== null;
    }
    setStockNotPresent(!stockAvailable);
  }, [productData, selectedCombination]);


  const handleYes = async () => {
    // Validate stock
    if (stockNotPresent) {
      if (stock === '' || stock === null || stock === undefined) {
        setStockError(true);
        alert.error('Please enter stock quantity');
        return;
      }

      const stockValue = Number(stock);
      if (isNaN(stockValue) || stockValue < 0) {
        setStockError(true);
        alert.error('Please enter a valid stock quantity');
        return;
      }
      if (onYes) {
        await onYes(selectedCombination, stockValue);
      }
    }
    else {
      if (onYes) {
        await onYes(selectedCombination, undefined);
      }
    }

  };

  const handleNo = async () => {
    // Validate stock before proceeding to reject
      setShowPriceInput(true);
 
    // ✅ Note: We don't close notification here because user is proceeding to submit a new price
    // The notification will be closed when they submit the new price in handleNewPriceSubmit
  };

  const handleNewPriceSubmit = async () => {
    if (!newPrice || newPrice <= 0) {
      alert.error('Please enter a valid price');
      return;
    }

    if (stockNotPresent) {
      if (stock === '' || stock === null || stock === undefined) {
        setStockError(true);
        alert.error('Please enter stock quantity');
        return;
      }
    }

    const stockValue = Number(stock);
    if (onNewPriceSubmit) {
      await onNewPriceSubmit(newPrice, stockNotPresent ? stockValue : undefined, selectedCombination);
      
      // ✅ Close notification after submitting new price request (rejection + counter-offer)
      if (closeNotificationAndRefresh) {
        await closeNotificationAndRefresh('price');
      }

      setSelectedCombination(null);
      setShowPriceInput(false);
      setNewPrice('');
      setMarginError(false);
      setStock('');
      setStockError(false);
      setSelectedGst(productData?.taxClass);
    } else {
      alert.error('Error: Submit function not available');
    }
    // handleClose();
  };

  const handleClose = () => {
    setShowPriceInput(false);
    setNewPrice('');
    setMarginError(false);
    setStock('');
    setStockError(false);
    setSelectedGst(productData?.taxClass || '18');
    setSelectedCombination(null);
    onHide();
  };

  const handleCombinationSelect = (combination) => {
    const fullCombinationData = productData?.vendor?.combination?.find(comb => comb.url === combination.url);
    if (fullCombinationData) {
      setSelectedCombination(fullCombinationData);
    } else {
      setSelectedCombination(combination);
    }
  };

  const handlePriceChange = (e) => {
    setNewPrice(e.target.value);
    setMarginError(false);
  };

  // Don't render if productData is null
  if (!productData) {
    return null;
  }


  return (
    <Modal show={show} onHide={handleClose} centered size="md" className='newPriceOfferPopup'>
      <style>
        {`
          .newPriceOfferPopup .modal-content {
            border: none !important;
            border-radius: 12px !important;
            padding: 0 !important;
            overflow: hidden !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2) !important;
          }
          .newPriceOfferPopup .modal-header {
            background: #3F8C8C !important;
            border: none !important;
            padding: 16px 20px !important;
          }
          .newPriceOfferPopup .modal-title {
            color: white !important;
            font-weight: 600 !important;
            font-size: 18px !important;
          }
          .newPriceOfferPopup .btn-close {
            filter: invert(1) !important;
          }
          .newPriceOfferPopup .modal-body {
            padding: 0 !important;
          }
          .price-comparison-card {
            background: #f8f9fa !important;
            border-radius: 8px !important;
            padding: 16px !important;
            margin: 8px !important;
          }
          .price-item {
            text-align: center !important;
          }
          .price-label {
            color: #6c757d !important;
            font-size: 12px !important;
            margin-bottom: 5px !important;
          }
          .price-value {
            font-size: 20px !important;
            font-weight: 700 !important;
            margin-bottom: 5px !important;
          }
          .price-gst {
            color: #6c757d !important;
            font-size: 12px !important;
          }
          .price-change {
            color: #3F8C8C !important;
            font-weight: 600 !important;
            font-size: 14px !important;
          }
          .message-box {
            background: #E0F2F1 !important;
            border: 1px solid #3F8C8C !important;
            border-radius: 6px !important;
            padding: 12px !important;
            margin: 10px !important;
            font-size: 14px !important;
            color: #333 !important;
          }
          .action-buttons {
            padding: 12px !important;
            display: flex !important;
            gap: 12px !important;
            justify-content: center !important;
          }
          .btn-reject {
            background: white !important;
            border: 1px solid #dee2e6 !important;
            color: #333 !important;
            border-radius: 6px !important;
            padding: 8px 16px !important;
            font-weight: 500 !important;
            font-size: 14px !important;
            min-width: 100px !important;
          }
          .btn-accept {
            background: #3F8C8C !important;
            border: none !important;
            color: white !important;
            border-radius: 6px !important;
            padding: 8px 16px !important;
            font-weight: 500 !important;
            font-size: 14px !important;
            min-width: 100px !important;
          }
          .trend-icon {
            color: #3F8C8C !important;
            font-size: 20px !important;
          }
          .newPriceOfferPopup input[type="number"]::placeholder {
            font-size: 14px !important;
            font-family: 'Open Sans', sans-serif !important;
            color: rgba(64, 57, 57, 0.5) !important;
          }
          
          /* Pushable Button Styling for Combinations */
          .enq-card-comb-div .pushable {
            margin: 4px !important;
            width: auto !important;
            min-width: 80px !important;
            height: auto !important;
          }
          
          .enq-card-comb-div .shadow {
            border-radius: 2px !important;
            background: hsl(0deg 0% 0% / 0.25) !important;
            transform: translateY(1px) !important;
          }
          
          .enq-card-comb-div .edge {
            border-radius: 2px !important;
            background: #3F8C8C !important;
          }
          
          .enq-card-comb-div .front {
            border-radius: 2px !important;
            background: #3F8C8C !important;
            transform: translateY(-1px) !important;
            padding: 6px 12px !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            font-family: 'Poppins' !important;
          }
          
          .enq-card-comb-div .pushable:hover .front {
            transform: translateY(-2px) !important;
          }
          
          .enq-card-comb-div .pushable:hover .shadow {
            transform: translateY(2px) !important;
          }
          
          .enq-card-comb-div .pushable:active .front {
            transform: translateY(0px) !important;
          }
          
          .enq-card-comb-div .pushable:active .shadow {
            transform: translateY(1px) !important;
          }
          
          .enq-card-comb-div .pushable.selected .edge {
            background: #1a4d4d !important;
          }
          
          .enq-card-comb-div .pushable.selected .front {
            background: #1a4d4d !important;
          }

          #newPriceReqOfferBodyCntn{
            max-height: 500px;
            overflow-y: auto;
          }
        `}
      </style>
      <Modal.Header closeButton>
        <Modal.Title>New Price Offer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showPriceInput ? (
          <>
            {/* Product Information */}
            <div id='newPriceReqOfferBodyCntn'>
              <div style={{ padding: '12px 16px 0 16px' }}>
                <div style={{ color: '#6c757d', fontSize: '11px', marginBottom: '4px' }}>Product</div>
                <div style={{ color: '#333', fontSize: '14px', fontWeight: '600' }}>
                  {productData?.productName || productData?.name || 'Product Name'}
                </div>
              </div>

              {/* Price Comparison Card */}
              {/* Only show prices if no combinations exist OR a combination is selected */}
              {(!productData?.combinations || productData.combinations.length === 0 || selectedCombination) ? (
                <div className="price-comparison-card">
                  {/* Show selected combination info if available */}
                  <div className="row">
                    <div className="col-4 price-item">
                      <div className="price-label">Current Price</div>
                      <div className="price-value text-black">
                        ₹ {(() => {
                          const currentPrice = selectedCombination
                            ? (selectedCombination.purchase_price || selectedCombination.price || 'N/A')
                            : (productData?.currentPrice);
                          return currentPrice;
                        })()}
                      </div>
                      <div className="price-gst">(incl. {selectedGst}% GST)</div>
                    </div>
                    <div className="col-4 d-flex align-items-center justify-content-center">
                      <i className="fas fa-chart-line trend-icon"></i>
                    </div>
                    <div className="col-4 price-item">
                      <div className="price-label">New Offer</div>
                      <div className="price-value" style={{ color: '#3F8C8C' }}>
                        ₹ {(() => {
                          let newPrice = 'N/A';
                          if (selectedCombination) {
                            // For combinations, we need to get the new price from the vendor data
                            // The newPrice in productData might be for a different combination
                            const combinationFromVendor = productData?.vendor?.combination?.find(comb => comb.url === selectedCombination.url);
                            newPrice = combinationFromVendor?.n_purchase_price ||
                              selectedCombination.n_purchase_price ||
                              'N/A';

                          } else {
                            newPrice = productData?.newPrice || 'N/A';
                          }
                          return newPrice;
                        })()}
                      </div>
                      <div className="price-gst">(incl. {selectedGst}% GST)</div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="price-comparison-card" style={{
                  textAlign: 'center',
                  padding: '20px',
                  color: '#6c757d'
                }}>
                  <i className="bi bi-box-seam" style={{ fontSize: '24px', marginBottom: '8px' }}></i>
                  <div style={{ fontSize: '14px', fontWeight: '500' }}>
                    Select a combination below to view price details
                  </div>
                </div>
              )}

              {/* Message Box */}
              <div className="message-box">
                From Toolsvilla: This is a new transfer price offer. Please review and accept.
              </div>

              {/* Prominent Selection Message */}
              {productData?.combinations && productData.combinations.length > 0 && !selectedCombination && (
                <div style={{
                  background: '#3F8C8C',
                  color: 'white',
                  padding: '6px 12px',
                  margin: '8px 16px',
                  borderRadius: '4px',
                  textAlign: 'center',
                  fontSize: '12px',
                  fontWeight: '500'
                }}>
                  ⚠️ Please select a combination to accept or reject the offer
                </div>
              )}

              {/* Combinations Section - Show if combinations exist */}
              {productData?.combinations && productData.combinations.length > 0 && (
                <div style={{
                  padding: '12px',
                  borderTop: '1px solid #e9ecef',
                  borderBottom: '1px solid #e9ecef',
                  backgroundColor: '#f8f9fa'
                }}>
                  <div style={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#333',
                    marginBottom: '8px',
                    textAlign: 'center'
                  }}>
                    New Transfer Price Offer from Toolsvilla for:
                  </div>
                  <div className="enq-card-comb-div d-flex flex-wrap justify-content-center">
                    {productData.combinations.map((item, index) => (
                      <button
                        className={`pushable m-1 ${(selectedCombination && selectedCombination.url === item.url) ? 'selected' : ''}`}
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCombinationSelect(item);
                        }}
                        style={{
                          width: 'auto',
                          minWidth: '80px',
                          height: 'auto',
                          margin: '4px'
                        }}
                      >

                        <span className="shadow"></span>
                        <span className="edge" style={{
                          background: (selectedCombination && selectedCombination.url === item.url) ? '#1a4d4d' : '#3F8C8C'
                        }}></span>
                        <span className="front" style={{
                          background: (selectedCombination && selectedCombination.url === item.url) ? '#1a4d4d' : '#3F8C8C',
                          padding: '6px 12px',
                          fontSize: '12px',
                          fontWeight: '600',
                          fontFamily: 'Poppins',
                          borderRadius: '2px',
                          minWidth: '80px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '4px'
                        }}>
                          {(selectedCombination && selectedCombination.url === item.url) && (
                            <i className="bi bi-check-circle-fill" style={{
                              fontSize: '12px',
                              color: '#4ade80'
                            }}></i>
                          )}
                          {item.cmb || item.com || 'Comb ' + (index + 1)}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Stock Input Section */}
              <div style={{
                padding: '3px',
                borderBottom: '1px solid #e9ecef',
                backgroundColor: '#f8f9fa'
              }}>
                {stockNotPresent && <div className="pd_Offcanvas_Grey_Box">
                  <p className="iscorr_trans_p row">
                    <span className="col-6 text-right">
                      Please enter stock :
                    </span>
                    <input
                      type="number"
                      className="pd_input_price col-2"
                      placeholder="Enter stock"
                      value={stock}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === '' || (Number(value) >= 0 && /^\d*$/.test(value))) {
                          setStock(value);
                          setStockError(false);
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      style={{
                        border: stockError ? '1px solid #dc3545' : ''
                      }}
                    />
                  </p>
                  {stockError && (
                    <div className="text-danger text-center mt-2" style={{ fontSize: '12px' }}>
                      Please enter a valid stock quantity
                    </div>
                  )}
                </div>}
              </div>

            </div>

            {/* Action Buttons */}
            <div className="action-buttons">
              <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', width: '100%' }}>
                <button
                  className="btn btn-reject"
                  onClick={handleNo}
                  disabled={productData?.combinations && productData.combinations.length > 0 && !selectedCombination}
                  style={{
                    opacity: (productData?.combinations && productData.combinations.length > 0 && !selectedCombination) ? 0.5 : 1,
                    cursor: (productData?.combinations && productData.combinations.length > 0 && !selectedCombination) ? 'not-allowed' : 'pointer',
                    flex: 1,
                    maxWidth: '150px'
                  }}
                >
                  Reject
                </button>
                <button
                  className="btn btn-accept"
                  onClick={handleYes}
                  disabled={productData?.combinations && productData.combinations.length > 0 && !selectedCombination}
                  style={{
                    opacity: (productData?.combinations && productData.combinations.length > 0 && !selectedCombination) ? 0.5 : 1,
                    cursor: (productData?.combinations && productData.combinations.length > 0 && !selectedCombination) ? 'not-allowed' : 'pointer',
                    flex: 1,
                    maxWidth: '150px'
                  }}
                >
                  Accept Offer
                </button>
              </div>
            </div>
          </>
        ) : (
          <div style={{ padding: '20px' }}>
            <div className="text-center mb-3">
              <div id='newPriceReqOfferBodyCntn'>
                <h5 className="mb-2" style={{ color: '#333', fontWeight: '600' }}>
                  New Price Request  <div className="enq-card-comb-div d-flex flex-wrap justify-content-center">
                    {productData.combinations.map((item, index) => {

                      if (selectedCombination && selectedCombination.url === item.url) {
                        return (
                          <button
                            className={`pushable m-1 ${(selectedCombination && selectedCombination.url === item.url) ? 'selected' : ''}`}
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCombinationSelect(item);
                            }}
                            style={{
                              width: 'auto',
                              minWidth: '80px',
                              height: 'auto',
                              margin: '4px'
                            }}
                          >

                            <span className="shadow"></span>
                            <span className="edge" style={{
                              background: (selectedCombination && selectedCombination.url === item.url) ? '#1a4d4d' : '#3F8C8C'
                            }}></span>
                            <span className="front" style={{
                              background: (selectedCombination && selectedCombination.url === item.url) ? '#1a4d4d' : '#3F8C8C',
                              padding: '6px 12px',
                              fontSize: '12px',
                              fontWeight: '600',
                              fontFamily: 'Poppins',
                              borderRadius: '2px',
                              minWidth: '80px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '4px'
                            }}>
                              {(selectedCombination && selectedCombination.url === item.url) && (
                                <i className="bi bi-check-circle-fill" style={{
                                  fontSize: '12px',
                                  color: '#4ade80'
                                }}></i>
                              )}
                              {item.cmb || item.com || 'Comb ' + (index + 1)}
                            </span>
                          </button>
                        )
                      }
                    }
                    )}
                  </div>
                </h5>
                <div className="mb-3">
                  <span className="text-muted small">
                    Current Transfer Price (incl. {productData?.taxClass || '18'}% GST) :
                  </span>
                  <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                    ₹ {(() => {
                      const currentPrice = selectedCombination
                        ? (selectedCombination.purchase_price || selectedCombination.price || 'N/A')
                        : (productData?.currentPrice);

                      return currentPrice;
                    })()}
                  </span>
                </div>
                <div className="mb-3">
                  <span className="text-muted small">Please Enter New Transfer Price :</span>
                </div>
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <span className="me-2" style={{ fontSize: '14px' }}>₹</span>
                  <input
                    type="number"
                    className="form-control"
                    value={newPrice}
                    onChange={handlePriceChange}
                    placeholder="Enter new price"
                    style={{
                      height: '32px',
                      maxWidth: '200px',
                      fontSize: '14px',
                      fontFamily: 'Open Sans, sans-serif'
                    }}
                  />
                </div>

                {/* Stock Input in Reject View */}
                {stockNotPresent && <div className="mb-3">
                  <div className="text-center mb-2">
                    <span className="text-muted small">
                      Stock:
                    </span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <i
                      className="bi bi-box-seam me-2"
                      aria-hidden="true"
                      style={{
                        fontSize: '14px',
                        // fontWeight: '500'
                      }}
                    ></i>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter stock"
                      value={stock}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === '' || (Number(value) >= 0 && /^\d*$/.test(value))) {
                          setStock(value);
                          setStockError(false);
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      style={{
                        maxWidth: '200px',
                        height: '32px',
                        border: stockError ? '1px solid #dc3545' : '1px solid #ced4da',
                        fontSize: '14px',
                        fontFamily: 'Open Sans, sans-serif'
                      }}
                    />
                  </div>
                </div>}

                {/* GST Section */}
                <div className="mb-3">
                  <div className="text-center mb-2">
                    <span className="text-muted small">GST :</span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <i
                      className="bi bi-percent me-2"
                      aria-hidden="true"
                      style={{
                        fontSize: '14px',
                        // fontWeight: '500'
                      }}
                    ></i>
                    <select
                      className="form-control"
                      value={selectedGst}
                      onChange={(e) => setSelectedGst(e.target.value)}
                      style={{
                        height: '32px',
                        maxWidth: '200px',
                        fontSize: '14px',
                        fontFamily: 'Open Sans, sans-serif'
                      }}
                    >
                      {variables?.variables?.gstValues.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <button
                  className="btn px-4"
                  onClick={handleNewPriceSubmit}
                  style={{
                    borderRadius: '6px',
                    background: '#3F8C8C',
                    border: 'none',
                    color: 'white',
                    fontWeight: '500'
                  }}
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
        )}

      </Modal.Body>
    </Modal>
  );
}

export default NewPriceOfferPopup;